import { Input } from '@chakra-ui/react';
import { NumberBlock as INumberBlock } from '@/lib/types';
import BaseInputBlock from './base-input-block';
import { useFillableBlockResponse } from './common';

interface Props {
  block: INumberBlock;
}

export default function NumberBlock({ block }: Props) {
  const { payload, updatePayload } = useFillableBlockResponse({ block });

  return (
    <BaseInputBlock block={block}>
      <Input
        id={`block-${block.referenceID}`}
        value={payload?.value || ''}
        type={'number'}
        onChange={(e) => updatePayload({ value: e.currentTarget.value })}
      />
    </BaseInputBlock>
  );
}
